var serviceUtil = (function($){
  /**
   * create an endpoint URL from the string
   * @param  {string} endpoint the basis of the endpoint
   * @param  {object} args     object with variables that should be implemented in the endpoint
   * @return {string}          the created endpoint
   */
  var createEndPoint = function(endpoint, args){
    var queryParamString;
    for (var key in args) {
      if (args.hasOwnProperty(key)) {
        var arg = args[key];
        var re = new RegExp('({'+key+'})',"g");
        if(endpoint.match(re)){
          endpoint = endpoint.replace(re, arg);
        }else{
          //if the parameter is not set in the endpoint, set is as a queryparameter at the end of the endpoint
          if(queryParamString === undefined){
            queryParamString = "?"+key+"="+arg;
          }else{
            queryParamString += "&"+key+"="+arg;
          }
        }
      }
    }

    //check if queryParamString is empty or not. if not add to endpoint
    if(queryParamString !== undefined){
      endpoint += queryParamString;
    }
    return endpoint;
  };

  return {
    createEndPoint: createEndPoint
  };
}(jQuery));

define("components/services/serviceUtil", function(){});

